// enums
import { usersType } from 'src/app/core/enums/user/user-type';

export const listOfUserType = [
    { name: 'إداري', type: usersType.all },
    { name: 'مشرف', type: usersType.admin },
    { name: 'الوسيط', type: usersType.office },
    { name: 'مشرف', type: usersType.superVisor },
    { name: 'مستخدم', type: usersType.normalUser },
]